var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { updateJasBoardsVerificationHistoryFunctionDef } from '../../../../backend/config/classifiers/platform-functions/updateJasBoardsVerificationHistory';
import { jasBoardVerificationHistoryEntityName } from '../../../../backend/features/jas-boards/shared';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { DataTable } from '@juvare/common-data-table-ui/DataTable';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { useEntityDataTable } from '@juvare/platform-sdk-react/ui/hooks';
import UpdateIcon from '@mui/icons-material/Update';
import { Button, Stack, Typography } from '@mui/material';
import React from 'react';
import { useJasBoardHistoryFilterConfig } from '../hooks/useJasBoardHistoryFilterConfig';
import { useJasBoardVerificationHistoryColumns } from '../hooks/useJasBoardHistoryVerificationColumns';
import { mapJasBoardHistoryFilterData } from '../utils/mapJasBoardHistoryFilterData';
const rowsPerPageOptions = [5, 10, 20];
export const JasBoardVerificationHistoryTable = ({ onClose, jasBoard }) => {
    const { t } = useCredentialingTranslation();
    const [updating, setUpdating] = React.useState(false);
    const { columns } = useJasBoardVerificationHistoryColumns();
    const { filterConfig } = useJasBoardHistoryFilterConfig();
    const updateJasBoardsVerificationHistory = useTypedPlatformFunction(updateJasBoardsVerificationHistoryFunctionDef);
    const mapEntityFilterData = (filterData) => {
        return mapJasBoardHistoryFilterData(filterData, jasBoard.id);
    };
    const { dataTableProps, reload } = useEntityDataTable({
        columns,
        defaultSortColumnKey: 'lastCheckedAt',
        entityName: jasBoardVerificationHistoryEntityName,
        filterConfig,
        mapEntityFilterData,
        title: t('table.jasBoardStatusHistory.labels.history'),
        tableSx: { tableLayout: 'fixed' },
    }, {
        defaultSortColumnDesc: true,
        defaultRowsPerPage: 5,
    });
    const handleUpdate = () => __awaiter(void 0, void 0, void 0, function* () {
        setUpdating(true);
        try {
            const { data } = yield updateJasBoardsVerificationHistory({ jasBoardId: jasBoard.id });
            if (data.success) {
                reload();
                showAlertSnackbar({
                    type: 'success',
                    message: t('table.jasBoardStatusHistory.alerts.rechecked'),
                    horizontalPosition: 'right',
                    autoHideDuration: 3000,
                });
            }
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
        setUpdating(false);
    });
    return (React.createElement(Stack, { p: 3, spacing: 3 },
        React.createElement(Typography, { variant: 'h6' },
            jasBoard.name,
            " ",
            t('table.jasBoardStatusHistory.labels.history')),
        React.createElement(DataTable, Object.assign({}, dataTableProps, { rowsPerPageOptions: rowsPerPageOptions, columns: columns, mainAction: {
                label: t('table.jasBoardStatusHistory.labels.updateStatus'),
                icon: React.createElement(UpdateIcon, null),
                onClick: handleUpdate,
                disabled: updating,
            } })),
        React.createElement(Stack, { justifyContent: 'end', direction: 'row' },
            React.createElement(Button, { onClick: onClose }, t('table.jasBoardStatusHistory.labels.close')))));
};
